import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { KompisSettings, fetchDEXFProductsForItemList } from '@inter-ikea-storageone/range';
import { useServiceSettings } from 'contexts/serviceSettings';
import { AppRoutes } from 'routes';
import { useCore } from 'contexts/core';
import { Spr2VpcMap } from 'rangeConfig/@types';
import { DesignSourceEnum } from '@insights/insights-data-provider';
import { useSceneHandler } from 'contexts/sceneHandler';
import { usePlannerConfig } from 'contexts/plannerConfig';

const getVpcFromSprId = async (settings: KompisSettings, sprId: string, spr2VpcMap: Spr2VpcMap) => {
  const vpc = spr2VpcMap[sprId.toUpperCase().replace('S', '')];
  if (vpc) {
    // We allready have SPR in our mapping. No need to get global SPR number
    return vpc;
  }
  // The number we get can either be an SPR or ART. If it starts with S or second number is a 9 we know it's an SPR
  const isSpr = sprId.toUpperCase().startsWith('S') || sprId[1] === '9';
  const prefix = isSpr ? 'SPR-' : 'ART-';
  const dexfId = `${prefix}${sprId.toUpperCase().replace('S', '')}`;

  // We don't have the SPR/ART in our mapping. Could be a local market variant. Check for global number
  const dexfData = await fetchDEXFProductsForItemList(settings, [dexfId]);
  return dexfData[0]?.content?.itemNoGlobal ? spr2VpcMap[dexfData[0]?.content?.itemNoGlobal] : null;
};

const LoadConfigFromSpr = ({ match }: any) => {
  const { loadVpcScene } = useSceneHandler();
  const { kompisSettings } = useServiceSettings();
  const {
    plannerConfig: { sprToVpcMap }
  } = usePlannerConfig();
  const history = useHistory();
  const coreApi = useCore();

  const sprId = match.params.sprId ?? '';

  useEffect(() => {
    getVpcFromSprId(kompisSettings, sprId, sprToVpcMap)
      .then(vpcCode => vpcCode ?? Promise.reject())
      .then(vpcCode => loadVpcScene(vpcCode, DesignSourceEnum.spr, { sprCode: sprId }))
      .then(scene => scene?.init())
      .then(scene => {
        if (scene?.initialized) {
          history.replace(AppRoutes.PLANNER);
        } else if (scene?.legacy) {
          history.replace(AppRoutes.SUMMARY);
        } else {
          return Promise.reject();
        }
      })
      .catch(() => {
        coreApi.emit.onLoadVpcFailure(undefined);
        history.replace(AppRoutes.HOME);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default LoadConfigFromSpr;
